import { useQuery } from "@tanstack/react-query";
import { GET_NDHM_HOST } from "../../constants/env";
import fetch from "../../fetch-client";
import { AxonGenericApiResponse } from "../../types/axon";

export type Facility = {
  facility_id: string;
  facility_name: string;
  district: string;
  state: string;
};


const getSuggestFacilities = async (
  hprIdNumber: string,
): Promise<AxonGenericApiResponse<Facility[]>> => {
  const NDHM_HOST = GET_NDHM_HOST();
  try {
    const requestOptions: RequestInit = {
      method: "GET",
      redirect: "follow",
      credentials: "include",
      mode: "cors",
    };
    const response = await fetch(
      `${NDHM_HOST}/abdm/nhpr/v1/hpr/${hprIdNumber}/facilities`,
      requestOptions,
    );
    return await response.json();
  } catch (error) {
    return { success: false };
  }
};

const useGetSuggestFacilities = (hprIdNumber: string) => {
  return useQuery(["get-suggest-facilities", hprIdNumber], () =>
    getSuggestFacilities(hprIdNumber),
  );
};

export default useGetSuggestFacilities;
